import { Box, BoxProps, Flex, Image } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '@cks-internal/react-base';
import logo from '../../assets/logo.svg';

type AppProps = {
  containerProps?: BoxProps;
};

export const AppLayout = (props: AppProps) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return (
      <Box {...props.containerProps}>
        <Outlet />
      </Box>
    );
  }

  return (
    <Box minH='100vh' bg='gray.50' {...props.containerProps}>
      <Box px='8' py='4' bg='white' borderBottomWidth='1px' borderColor='gray.200'>
        <Image height='10' src={logo} alt='ChemRx' />
      </Box>
      <Flex direction='column' align='center' justify='center' flex='1' minH='calc(100vh - 73px)' px='4'>
        <Box w='full' maxW='lg'>
          <Outlet />
        </Box>
      </Flex>
    </Box>
  );
};
